export const composeDiamAccountPortalUrl = (ssoToken: string, language: string) => {
  return String(process.env.DIAM_ACCOUNT_PORTAL_URL)
    .concat('?token=')
    .concat(encodeURIComponent(ssoToken))
    .concat('&language=')
    .concat(encodeURIComponent(language));
};
